import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function InscriptionEcole() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    school_name: "",
    email: "",
    password: "",
    phone: "",
    city: "",
    postal_code: "",
  });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Le mot de passe doit contenir au moins 6 caractères.");
      return;
    }
    setLoading(true);
    try {
      await register(form);
      navigate("/pro");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const field = (key, placeholder, type = "text") => (
    <input
      data-testid={`register-${key.replace("_", "-")}-input`}
      type={type}
      value={form[key]}
      onChange={(e) => set(key, e.target.value)}
      placeholder={placeholder}
      className="w-full rounded-lg border border-neutral-300 bg-white px-4 py-3 outline-none focus:border-brand transition-colors"
    />
  );

  return (
    <div className="min-h-screen bg-[#FAFAFA] px-6 py-20">
      <div className="mx-auto max-w-lg">
        <Link to="/" className="inline-block">
          <Logo className="h-20" />
        </Link>
        <h1 className="mt-12 text-4xl font-extrabold tracking-tighter">Rejoindre le réseau PlanPermis</h1>
        <p className="mt-3 text-neutral-500">
          Vous avez des places disponibles en formation accélérée ? Recevez des élèves pressés, dans vos zones. Vous ne
          payez la commission qu'après une inscription confirmée par l'élève.
        </p>
        <form onSubmit={submit} className="mt-10 space-y-4">
          {field("school_name", "Nom de l'auto-école")}
          {field("email", "Email professionnel", "email")}
          {field("password", "Mot de passe (6 caractères min.)", "password")}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="sm:col-span-2">{field("city", "Ville")}</div>
            {field("postal_code", "Code postal")}
          </div>
          {field("phone", "Téléphone")}
          <button
            type="submit"
            disabled={loading}
            data-testid="register-submit-btn"
            className="w-full rounded-full bg-brand px-6 py-4 font-bold text-white transition-colors hover:bg-brand-hover disabled:opacity-60"
          >
            {loading ? "Création…" : "Créer mon compte partenaire"}
          </button>
        </form>
        <p className="mt-8 text-sm text-neutral-500">
          Déjà un compte ?{" "}
          <Link to="/connexion" data-testid="goto-login-link" className="font-semibold text-brand underline underline-offset-4">
            Se connecter
          </Link>
        </p>
      </div>
    </div>
  );
}
